import { createContext, useContext, useEffect, useState } from "react";
import { clientApi, CLIENT_TOKEN_KEY } from "../lib/clientApi";

const ClientAuthContext = createContext(null);

export const ClientAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(CLIENT_TOKEN_KEY);
    if (!token) {
      setLoading(false);
      return;
    }
    clientApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem(CLIENT_TOKEN_KEY))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await clientApi.post("/auth/login", { email, password });
    localStorage.setItem(CLIENT_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await clientApi.post("/auth/register", payload);
    localStorage.setItem(CLIENT_TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const updateProfile = async (payload) => {
    const { data } = await clientApi.put("/auth/profile", payload);
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(CLIENT_TOKEN_KEY);
    setUser(null);
  };

  return (
    <ClientAuthContext.Provider value={{ user, loading, login, register, updateProfile, logout }}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export const useClientAuth = () => {
  const ctx = useContext(ClientAuthContext);
  if (!ctx) throw new Error("useClientAuth must be used inside ClientAuthProvider");
  return ctx;
};
